import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import { canvasToolbarShellVariants } from "./canvasToolbarStyles";

export type CanvasToolbarRegister = "contextual" | "primary";

interface CanvasToolbarShellProps extends ComponentPropsWithoutRef<"div"> {
  register?: CanvasToolbarRegister;
}

export function CanvasToolbarShell({
  register = "contextual",
  className,
  children,
  ...rest
}: CanvasToolbarShellProps) {
  return (
    <div
      role="toolbar"
      className={cn(canvasToolbarShellVariants({ register }), className)}
      {...rest}
    >
      {children}
    </div>
  );
}
